import { isNil } from 'lodash';

import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';

import type { Dispatch, GetState, InfluencerMetaMap, ThunkAction } from 'types';

const INFLUENCERS_META_LOADED = 'influencers_meta/INFLUENCERS_META_LOADED';
const RESET = 'influencers_meta/RESET';

const initialState: InfluencerMetaMap = {};

export function influencersMetaLoaded(data: InfluencerMetaMap) {
  return {
    type: INFLUENCERS_META_LOADED,
    payload: {
      data
    }
  };
}

export function resetInfluencerMeta() {
  return {
    type: RESET,
    payload: {}
  };
}

export const fetchInfluencersMeta = (influencerIds: Array<number|string>): ThunkAction => (dispatch: Dispatch, getState: GetState) => {
  const orgId = getState().organizations.currentOrganization?.id;

  if (isNil(orgId)) {
    throw new Error('Invalid organization Id');
  }

  if (influencerIds.find(n => typeof n === 'string')) {
    // Not sure how COLLAB-14827 was possible, but we can monitor that
    logError('Got string Id, but only numbers are expected');
  }

  const mappedInfluencerIds = influencerIds
    .map(n => Number(n));

  if (mappedInfluencerIds.find(n => Number.isNaN(n))) {
    throw new Error('Got invalid influencer Id value');
  }

  const url = API.END_POINTS.INFLUENCERS.getInfluencersMeta(orgId, mappedInfluencerIds);
  return get(url)
    .then(response => { dispatch(influencersMetaLoaded(response.data)); })
    .catch(resetInfluencerMeta);
};

export default createReducer<InfluencerMetaMap, any>('influencersMeta', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [INFLUENCERS_META_LOADED]: (
    state: InfluencerMetaMap,
    {
      data
    }: {
      data: InfluencerMetaMap
    }
  ): InfluencerMetaMap => ({
    ...state,
    ...data
  })
});
